import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  #ignoreNextOutsideClick = false;

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

    document.addEventListener(
      'click',
      this.#handleOutsideClick
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      CartAddEvent.eventName,
      this.#handleCartAdd
    );

    document.removeEventListener(
      'click',
      this.#handleOutsideClick
    );
  }

  #handleCartAdd = () => {
    if (!this.hasAttribute('auto-open')) {
      return;
    }

    this.showDialog();
  };

  #handleOutsideClick = (event) => {
    // Ignore the click that opened the drawer
    if (this.#ignoreNextOutsideClick) {
      this.#ignoreNextOutsideClick = false;
      return;
    }

    // Drawer ke andar click hua
    if (event.target.closest('.cart-drawer__dialog')) {
      return;
    }

    // Drawer ke bahar click hua
    if (this.open) {
      this.closeDialog();
    }
  };

  open() {
    this.#ignoreNextOutsideClick = true;

    this.showDialog();

    customElements
      .whenDefined('shopify-payment-terms')
      .then(() => {
        const installmentsContent =
          document
            .querySelector('shopify-payment-terms')
            ?.shadowRoot;

        const cta =
          installmentsContent?.querySelector(
            '#shopify-installments-cta'
          );

        cta?.addEventListener(
          'click',
          this.closeDialog,
          { once: true }
        );
      })
      .catch(() => {});
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define(
    'cart-drawer-component',
    CartDrawerComponent
  );
}